/**
 *
 * AppHeader
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { Header } from './styledComponents';
import SearchField from '../../../../components/SearchField/SearchField.component';
import { NavLink, useHistory } from 'react-router-dom';
import { useQueryParams } from 'use-query-params';
import { AppQueryParamsConfigMap } from '../../../../app/constants';
import { useEventFeed } from '../../../../api/useEventFeed';
import useSearchQuery from './useSearchQuery';
import useChangeLocationSearch from '../../../../hooks/useChangeLocationSearch';
import useHidingHeader from '../../../../hooks/useHidingHeader';


interface IProps {}


const AppHeader: FunctionComponent<IProps> = () => {
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const { data: activeEvent } = useEventFeed({ eventId: query.e });
  const history = useHistory();
  const { searchQuery, changeQuery, placeholder } = useSearchQuery();

  const getModifiedSearchQuery = useChangeLocationSearch();
  const style = useHidingHeader();

  return (
    <Header style={style}>
      <div className="header-menu">
        <div className="header-menu__inner">
          <div className="header-menu__item">
            <NavLink
              to={{
                pathname: '/all-events',
                search: history.location.search,
              }}
              activeClassName="active"
              className="header-menu__item-link"
            >
              All events
            </NavLink>
          </div>
          {activeEvent && (
            <div className="header-menu__item">
              <NavLink
                to={{
                  pathname: '/feed',
                  search: getModifiedSearchQuery([
                    { param: 'c', value: undefined },
                  ]),
                }}
                className="header-menu__item-link"
              >
                Summary
              </NavLink>
              <div className="lbl">{activeEvent.eventName}</div>
            </div>
          )}
        </div>
      </div>
      <SearchField
        style={style}
        className="header-menu__search"
        value={searchQuery}
        onChange={(v) => changeQuery(v)}
        placeholder={placeholder}
      />
    </Header>
  );
};

export default memo(AppHeader);
